function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { request, useQuery } from '@applyboard/ui-utils';
var defaultData = [];
export function useRecruitmentPartnerManagers() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useQuery = useQuery(['recruitment_partner_managers', {
      pkg: 'business-ui-legacy'
    }], function () {
      return request("/api/v2/recruitment_partner_managers?include=user&fields[agent_manager]=user&fields[user]=full_name,email", {
        defaultResponse: {
          data: [],
          included: []
        },
        // eslint-disable-next-line no-restricted-syntax
        isExpectedResponse: isExpectedResponse
      }).then(function (res) {
        var includedUsersMap = res.included.reduce(function (acc, curr) {
          if (isUser(curr)) {
            acc[curr.id] = curr;
          }
          return acc;
        }, {});
        return res.data.map(function (dataItem) {
          var user = includedUsersMap[dataItem.relationships.user.data.id];
          if (!user) {
            throw new Error('Missing user');
          }
          return {
            email: user.attributes.email,
            fullName: user.attributes.full_name,
            id: dataItem.id
          };
        });
      });
    }, {
      enabled: options.enabled,
      refetchOnWindowFocus: false,
      refetchInterval: false
    }),
    isLoading = _useQuery.isLoading,
    error = _useQuery.error,
    data = _useQuery.data;
  return {
    isLoadingRecruitmentPartnerManagers: isLoading,
    recruitmentPartnerManagersError: error,
    recruitmentPartnerManagers: data || defaultData
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isUser(obj) {
  return obj.type === 'user';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isExpectedResponse(res) {
  return res && _typeof(res) === 'object' && Array.isArray(res.data) && Array.isArray(res.included);
}